import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import api from '../api';
import { Observable } from 'rxjs';

import { AccessInfo } from '../../models/AccessInfo.model';
import { AppConfig } from '../app.config.service';
import { UserAccessInfo } from '../../models/UserAccessInfo.model';

@Injectable()
export class ManageLogService {
  constructor(public http: HttpClient) { }

  GetAccess(fromTime: Date, toTime: Date): Observable<Array<AccessInfo>> {
    if (fromTime == null || fromTime == undefined || toTime == null || toTime == undefined) {
      toTime = new Date();
      fromTime = new Date(+(new Date()) - (AppConfig.Settings.TABLE_CALENDAR_RANGE * 24 * 3600 * 1000))
    }
    fromTime = new Date(fromTime.setHours(0, 0, 0, 0));
    toTime = new Date(toTime.setHours(23, 59, 59, 999));
    const params = new HttpParams()
      .set('fromTime', fromTime.toISOString())
      .set('toTime', toTime.toISOString());
    return this.http.get<Array<AccessInfo>>(`${api.url}${api.Admin.Admin}/${api.Admin.Access}`, { params });
  }

  GetUserAccess(fromTime: Date, toTime: Date): Observable<Array<UserAccessInfo>> {
    if (fromTime == null || fromTime == undefined || toTime == null || toTime == undefined) {
      toTime = new Date();
      fromTime = new Date(+(new Date()) - (AppConfig.Settings.TABLE_CALENDAR_RANGE * 24 * 3600 * 1000))
    }
    fromTime = new Date(fromTime.setHours(0, 0, 0, 0));
    toTime = new Date(toTime.setHours(23, 59, 59, 999));
    const params = new HttpParams()
      .set('fromTime', fromTime.toISOString())
      .set('toTime', toTime.toISOString());
    return this.http.get<Array<UserAccessInfo>>(`${api.url}${api.Admin.Admin}/${api.Admin.UserAccess}`, { params });
  }
}

